import RecoverStep from "./recover_step";
import {attachSelectableHandler} from "../utils/recover_utils";

const TEMPLATE = 'type';

export default class TypeStep extends RecoverStep {

  constructor() {
    super(TEMPLATE);
  }

  open(data, el, fr, previousStep) {
    data.tmp = { previousStep: fr.currentStep };
  }

  postRender(data, el, fr) {
    attachSelectableHandler(el, (d) => {
      data.recovery.type = d.type;
    });
  }

  transitionBack(data, el, fr) {
    const previousPage = (data.flowName === 'GeneralResellerRecoverFlow' && !data.clientHasBrcAndX360Recover)
        ? 'clientSelect'
        : 'recoverToolSelect';

    fr.goTo(previousPage);
  }

}
